import axios from 'axios';

export default {
    name: 'force-password-change',
    props: ['token', 'user'],
    data() {
        return {
            currentPassword: '',
            password: '',
            rules: [
                {
                    show: true,
                    icon: 'check',
                    color: 'gray-10',
                    specialCharacters: false,
                    message: this.$t('HC_MIN_CHAR'),
                    regex: /.{9,}/
                },
                {
                    show: true,
                    icon: 'check',
                    color: 'gray-10',
                    specialCharacters: false,
                    message: this.$t('HC_ONE_UPPERCASE'),
                    regex: /[A-Z]+/
                },
                {
                    show: true,
                    icon: 'check',
                    color: 'gray-10',
                    specialCharacters: false,
                    message: this.$t('HC_ONE_LOWERCASE'),
                    regex: /[a-z]+/
                },
                {
                    show: true,
                    icon: 'check',
                    color: 'gray-10',
                    specialCharacters: false,
                    message: this.$t('HC_ONE_NUMBER'),
                    regex: /[0-9]+/
                },
                {
                    show: true,
                    icon: 'check',
                    color: 'gray-10',
                    specialCharacters: false,
                    message: this.$t('HC_AT_LEAST_ONE_SPECIAL_CHARACTER'),
                    regex: /[!#$%&?@_~<=>*-]+/
                },
                {
                    show: false,
                    icon: 'times',
                    color: 'red-30',
                    specialCharacters: true,
                    message:
                        this.$t('HC_SPECIAL_CHARACTER') +
                        '! # $ % & * - < = > ? @ _ ~',
                    regex: /^[A-Za-z0-9!#$%&?@_~<=>*-]+$/
                }
            ],
            passwordConfirm: '',
            showConfirmHint: false,
            buttonClasses: ['is-fullwidth'],
            passwordType: 'password',
            passwordConfirmType: 'password',
            currentPasswordType: 'password',
            loadingState: false
        };
    },
    computed: {
        showValidationMessages() {
            return this.passwordValidation.passwordRules.filter(function(rule) {
                return rule.show;
            });
        },
        passwordValidation() {
            let passwordRules = this.rules;
            let valid = true;
            let isInputEmpty = this.password.length <= 0;

            for (let condition of passwordRules) {
                if (condition.specialCharacters) {
                    if (!condition.regex.test(this.password)) {
                        if (isInputEmpty) {
                            condition.show = false;
                        } else {
                            condition.show = true;
                        }
                        condition.color = 'red-30';
                        valid = false;
                    } else {
                        condition.show = false;
                        condition.color = 'gray-10';
                    }
                } else {
                    if (!condition.regex.test(this.password)) {
                        condition.color = 'gray-10';
                        valid = false;
                    } else {
                        condition.color = 'quore-green';
                    }
                }
            }
            return {
                valid: valid,
                passwordRules
            };
        },
        samePasswords() {
            return (
                this.password === this.passwordConfirm &&
                this.password &&
                this.passwordConfirm
            );
        },
        validPassword() {
            return this.samePasswords && this.passwordValidation.valid;
        }
    },
    methods: {
        onConfirmFocus() {
            this.showConfirmHint = true;
        },
        onSubmit() {
            this.loadingState = true;
            this.$emit('currentAlert', null);

            let data = {
                username: this.user.username,
                currentPassword: this.currentPassword,
                newPassword: this.password
            };
            axios
                .post(
                    `${process.env.VUE_APP_QV4_API}/users/force-password-change`,
                    data,
                    {
                        headers: {
                            'x-api-key': this.token
                        }
                    }
                )
                .then(() => {
                    let alert = {
                        message: this.$t('HC_SUCCESS_UPDATED_ACCOUNT'),
                        status: '',
                        icon: 'check-circle-outline'
                    };
                    this.$emit('currentAlert', alert);
                    this.$emit('currentView', 'login-form');
                    this.$emit('currentTransition', 'component-slide-fade-left');
                })
                .catch((error) => {
                    this.loadingState = false;
                    
                    let alertMessage = this.$t('HC_OOPS_BADUSERNAME');
                    
                    // Check if the error message contains the specific password reuse message
                    if (error.response && error.response.data && error.response.data.error) {
                        const errorMessage = error.response.data.error;
                        if (errorMessage.includes('Password cannot be the same as any of your previous 4 passwords')) {
                            alertMessage = this.$t('HC_PASSWORD_CANNOT_BE_THE_SAME');
                        }
                    }
                    
                    let alert = {
                        message: alertMessage,
                        status: 'danger',
                        icon: 'exclamation-circle-outline'
                    };
                    this.$emit('currentAlert', alert);
                });
        }
    }
}; 